// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  width: 100%;
  height: 100vh;
  /* background: linear-gradient(
    90deg,
    rgba(65, 12, 177, 1) 30%,
    rgba(206, 214, 228, 1) 30%
  ); */

   background: linear-gradient(
    90deg,
    #002824 30%,
    #D6D6D6 30%
  );
  /* background-color: #D6D6D6; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-field {
  height: 45px;
  border: 1px solid;
  border-radius: 3px;
}

.card {
  width: 85%;
  height: 80%;
  border-radius: 10px;
  border: 1px rgba(255, 255, 255, 0.3) solid;
  display: flex;
}

.left {
  width: 26.4%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: #002824;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.left-content {
  width: 80%;
}

.left-title {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 50px;
}

.login-steps {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.login-step {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 5px;
}

.step-desc {
  font-size: 12px;
}

.step-icon {
  margin-bottom: 5px;
}

.right {
  width: 73.6%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  justify-content: center;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  position: relative;
}

.box {
  width: 60%;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
}

.show-password {
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}

.forgot-password {
  font-size: 14px;
}

.signup {
  font-size: 14px;
  position: absolute;
  bottom: 12px;
}

@media only screen and (max-width: 650px) {
  
  .left{
    display: none;
  }

   .card {
      border: none;
          }

          .right {
            /* background-color: red; */
            width: 100%;
            margin: auto;
            border-radius: 8px;
            align-items: center;
            /* align-self: center; */
                      }

                      #loginButton {
                        /* background-color: red; */
                        width: 100%;
                        align-self: center;
                        /* margin: auto; */
                        margin-left: 0;
                      }

                      .box {
                        width: 100%;
                      }

                      .login-container {
                        background-color: #181818;
                      }
    
  }
  


@media only screen and (max-width: 307px) {
  .right {
    
    width: 307px;
   
    /* align-self: center; */
              }
 
  
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/styles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb;;;;MAII;;GAEH;;;;GAIA;EACD,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE;IACE,aAAa;EACf;;GAEC;MACG,YAAY;UACR;;UAEA;YACE,2BAA2B;YAC3B,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,mBAAmB;YACnB,wBAAwB;sBACd;;sBAEA;wBACE,2BAA2B;wBAC3B,WAAW;wBACX,kBAAkB;wBAClB,kBAAkB;wBAClB,cAAc;sBAChB;;sBAEA;wBACE,WAAW;sBACb;;sBAEA;wBACE,yBAAyB;sBAC3B;;EAEpB;;;;AAIF;EACE;;IAEE,YAAY;;IAEZ,wBAAwB;cACd;;;AAGd","sourcesContent":[".login-container {\n  width: 100%;\n  height: 100vh;\n  /* background: linear-gradient(\n    90deg,\n    rgba(65, 12, 177, 1) 30%,\n    rgba(206, 214, 228, 1) 30%\n  ); */\n\n   background: linear-gradient(\n    90deg,\n    #002824 30%,\n    #D6D6D6 30%\n  );\n  /* background-color: #D6D6D6; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.input-field {\n  height: 45px;\n  border: 1px solid;\n  border-radius: 3px;\n}\n\n.card {\n  width: 85%;\n  height: 80%;\n  border-radius: 10px;\n  border: 1px rgba(255, 255, 255, 0.3) solid;\n  display: flex;\n}\n\n.left {\n  width: 26.4%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  background-color: #002824;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.left-content {\n  width: 80%;\n}\n\n.left-title {\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 50px;\n}\n\n.login-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.login-step {\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.step-desc {\n  font-size: 12px;\n}\n\n.step-icon {\n  margin-bottom: 5px;\n}\n\n.right {\n  width: 73.6%;\n  height: 100%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 12px;\n  justify-content: center;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  position: relative;\n}\n\n.box {\n  width: 60%;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.show-password {\n  font-size: 12px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.forgot-password {\n  font-size: 14px;\n}\n\n.signup {\n  font-size: 14px;\n  position: absolute;\n  bottom: 12px;\n}\n\n@media only screen and (max-width: 650px) {\n  \n  .left{\n    display: none;\n  }\n\n   .card {\n      border: none;\n          }\n\n          .right {\n            /* background-color: red; */\n            width: 100%;\n            margin: auto;\n            border-radius: 8px;\n            align-items: center;\n            /* align-self: center; */\n                      }\n\n                      #loginButton {\n                        /* background-color: red; */\n                        width: 100%;\n                        align-self: center;\n                        /* margin: auto; */\n                        margin-left: 0;\n                      }\n\n                      .box {\n                        width: 100%;\n                      }\n\n                      .login-container {\n                        background-color: #181818;\n                      }\n    \n  }\n  \n\n\n@media only screen and (max-width: 307px) {\n  .right {\n    \n    width: 307px;\n   \n    /* align-self: center; */\n              }\n \n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
